export const ACTIVE_SMS_ALERT_LIMIT = 3;
export const MONTHLY_SMS_SEGMENT_LIMIT = 372;
export const OUTBOUND_SMS_SEGMENT_LIMIT = 4;
export const AUTOMATED_SMS_SEGMENT_LIMIT = OUTBOUND_SMS_SEGMENT_LIMIT;
export const DAILY_SMS_LIMIT = 3;
export const MATCHING_SMS_TYPES = ["swell", "wind", "tide", "forecast_match"] as const;
export function isMatchingSmsType(type: string): boolean {
  return (MATCHING_SMS_TYPES as readonly string[]).includes(type);
}
/** Spell out small daily allowances in phrases such as "three-text total". */
function allowanceWord(value: number): string {
  const small = ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine",
    "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen"];
  if (Number.isInteger(value) && value >= 0 && value < 20) return small[value];
  if (Number.isInteger(value) && value >= 20 && value < 100) {
    const tens = ["", "", "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety"];
    return tens[Math.floor(value / 10)] + (value % 10 ? `-${small[value % 10]}` : "");
  }
  return String(value);
}

/** One formatter for production policy and policy-change contract tests. */
export function buildSmsLimitNotices({
  activeAlerts = ACTIVE_SMS_ALERT_LIMIT,
  dailyTexts = DAILY_SMS_LIMIT,
  monthlySegments = MONTHLY_SMS_SEGMENT_LIMIT,
  automatedSegments = AUTOMATED_SMS_SEGMENT_LIMIT,
} = {}) {
  const segmentRange = automatedSegments === 1 ? "1 segment" : `1–${automatedSegments} segments`;
  return {
    monthlyPolicy: `Pro allows ${dailyTexts} automated alert ${dailyTexts === 1 ? "text" : "texts"} per day across all alerts, resetting at 12:01 a.m. in your confirmed home time zone. Wind, Swell, Tide and Forecast Match each send at most one SMS per alert per day. Daily reports, Forecast Outlook and alert tests also count toward the ${allowanceWord(dailyTexts)}-text total. The monthly allowance remains ${monthlySegments} billable ${monthlySegments === 1 ? "segment" : "segments"} per UTC calendar month; a text uses ${segmentRange}. Only SMS pauses at a limit; selected email and push continue. Agent chat and phone verification are separate.`,
    alertLimitMessage: `Your Pro plan allows ${activeAlerts} active SMS-enabled ${activeAlerts === 1 ? "alert" : "alerts"} per account. Pause an alert or turn off its SMS delivery before enabling another.`,
  };
}

const smsLimitNotices = buildSmsLimitNotices();
export const SMS_MONTHLY_POLICY = smsLimitNotices.monthlyPolicy;
export const SMS_ALERT_LIMIT_ERROR = "sms_alert_limit_reached";
export const SMS_ALERT_LIMIT_MESSAGE = smsLimitNotices.alertLimitMessage;

export function isActiveSmsAlert(alert: {
  active?: boolean | null;
  deliveryChannels?: string[] | null;
}): boolean {
  return alert.active === true && !!alert.deliveryChannels?.includes("sms");
}
